export default "/icon-nav-programs.svg";